import { postImage } from '@/api/image.api';
import { postUserConfiguration, putUserConfiguration } from '@/api/userConfiguration.api';
import Events from '@/services/Events';
import useProductStore from '@/store/product.store';
import { t } from '@/translations/i18n';
import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { IProduct } from '@/typescript/interfaces/IProduct';

async function saveUserConfig(prestashopUserId: number, prestashopSessionToken: string): Promise<number> {
    const productStore = useProductStore();
    const currentProduct = await saveUserImages(productStore.selectedProduct);
    try {
        if (currentProduct.prestashopUserId) {
            await putUserConfiguration(currentProduct, prestashopSessionToken);
        } else {
            const newProduct = await postUserConfiguration(currentProduct, prestashopUserId, prestashopSessionToken);
            productStore.selectedProduct = newProduct;
        }
        Events.emit('call-toaster', { title: t('save_success'), type: 'success' });
    } catch (e) {
        Events.emit('call-toaster', { title: t('error_title'), body: `${e}`, type: 'error' });
    }
    return productStore.selectedProduct.id || -1;
}

async function saveUserImages(product: IProduct) {
    product.configuration.fields = await Promise.all(
        product.configuration.fields.map(async (field: IImageField) => {
            if (!('defaultText' in field) && !field.uuid && field.url && field.filename) {
                const blob = await (await fetch(field.url)).blob();
                const file = new File([blob], field.filename);
                try {
                    field.uuid = await postImage(file);
                } catch (error) {
                    Events.emit('call-toaster', { title: t('error_title'), body: error as string, type: 'error' });
                }
            }
            return field;
        }),
    );
    return product;
}

export { saveUserConfig };
